import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FormGroup, Label } from './styles/common';
import { reactSelectStyles } from './reactSelectStyles';

// Moto twin of FormReactSelectBrand — same behaviour and v2 styling, keyed on
// the moto option shape (`brand_code` instead of `id`) and `moto_brand_code`.
function FormReactSelectMotoBrand({
  label, options, error, valid, onChange, values,
}) {
  const [prepOptions, setPrepOptions] = useState([]);
  const [inputText, setInputText] = useState('');

  const handleChange = (value) => {
    if (value.moto_brand_code !== undefined || value.moto_brand_code !== '') {
      const brand = options.find((opt) => opt.brand_code == value.moto_brand_code);
      if (brand !== undefined) {
        onChange({
          moto_brand_code: brand.brand_code.toString(),
        });
      }
    }

    if (value.moto_brand_code === null || value.moto_brand_code === '' || value.moto_brand_code === undefined) {
      onChange({
        moto_brand_code: '',
      });
    }
  };

  const handleInputChange = (inputValue) => {
    setInputText(inputValue);
  };

  const handleMenuClose = () => {
    if (!values.moto_brand_code && inputText) {
      const startingWithOptions = prepOptions.filter((option) => option.label.toLowerCase().startsWith(inputText.toLowerCase()));
      const firstStartingOption = startingWithOptions[0];
      const found = firstStartingOption
        && options.find((opt) => opt.brand_code == firstStartingOption.value);
      if (firstStartingOption && found) {
        onChange({
          moto_brand_code: firstStartingOption.value.toString(),
        });
      }
    }
  };

  useEffect(() => {
    setPrepOptions(options.map((i) => ({ value: i.brand_code, label: i.name })));
  }, [options]);

  return (
    <FormGroup>
      <Label>{label}</Label>
      <Select
        onMenuClose={handleMenuClose}
        onInputChange={handleInputChange}
        options={prepOptions}
        isSearchable
        placeholder="Cerca la marca..."
        value={options.filter((opt) => opt.brand_code == values.moto_brand_code).map((o) => ({ value: o.brand_code, label: o.name }))[0] ?? ''}
        onChange={(val) => {
          handleChange({
            moto_brand_code: val === null || val === undefined ? '' : val.value,
          });
        }}
        loadingMessage={() => 'Caricando marce...'}
        clearValue
        isClearable
        noOptionsMessage={() => 'Marce non trovati!'}
        styles={reactSelectStyles({ error, valid })}
      />
      <div className="invalid-feedback">{error}</div>
    </FormGroup>
  );
}

export default FormReactSelectMotoBrand;
